import styled from 'styled-components';
import { Icon as IconComponent } from '@elfsight/lib-icon';
import { getInvertedColor } from '@elfsight/widget-utils';

type MarkerProps = {
  iconUrl?: string;
  color?: string;
};

export const Marker = ({ color = '#111', iconUrl }: MarkerProps) => {
  const invertedColor = getInvertedColor(color);

  return (
    <Container>
      <MarkerBody
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 40 45"
        fill="none"
      >
        <path
          d="M39 20.0909C39 30.6345 30.4934 38.2273 20 43C9.50659 38.2273 1 30.6345 1 20.0909C1 9.54729 9.50659 1 20 1C30.4934 1 39 9.54729 39 20.0909Z"
          fill={color}
        />
        <path
          d="M19.793 43.4551L20 43.5493L20.207 43.4551C30.7479 38.6608 39.5 30.9422 39.5 20.0909C39.5 9.2734 30.7718 0.5 20 0.5C9.2282 0.5 0.5 9.2734 0.5 20.0909C0.5 30.9422 9.25209 38.6608 19.793 43.4551Z"
          stroke={invertedColor}
          strokeOpacity="0.1"
        />
      </MarkerBody>
      {iconUrl ? (
        <Icon size={20} src={iconUrl} fill={invertedColor} />
      ) : (
        <Dot _color={invertedColor} />
      )}
    </Container>
  );
};

export const MarkerBody = styled.svg`
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 38px;
  height: 42px;
`;

const Container = styled.div`
  position: relative;
  transition: 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);

  &:hover,
  .hovered & {
    transform: scale(1.1);
  }

  .active & {
    transform: scale(1.3);
  }
`;

export const Dot = styled.div<{ _color: string }>`
  width: 12px;
  height: 12px;
  background: ${({ _color }) => _color};
  border-radius: 100%;
  position: absolute;
  top: 13px;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
`;

const Icon = styled(IconComponent)`
  position: absolute;
  top: 9px;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
`;
